'use strict';

import {get_single_select_choices_options} from '../utils/Choices.js';

export class ChoiceSelect {
	async multiSelect(multiClass) {
		const multi = document.querySelectorAll(multiClass);

		if ( ! multi || multi.length === 0) {
			return;
		}

		try {
			const { default: Choices } = await import(/* webpackChunkName: "choices" */ 'choices.js');
			multi.forEach((select) => {
				if (!select.classList.contains('choices__input')) {
					try {
						const choicesOptions = {
							shouldSortItems: false,
							removeItemButton: true,
							allowHTML: select.dataset.html === 'true'
						}

						if (select.placeholder) {
							choicesOptions.placeholder = true;
							choicesOptions.placeholderValue = select.placeholder;
						}

						new Choices( select, choicesOptions);
					} catch ( error ) {
						console.error( error.message );
					} finally {
					}
				}
			})
		} catch (error) {
			console.error( error.message );
		}
	}

	async singleSelect(choices_additional_args) {
		const single = document.querySelectorAll('.single_choices select, select.single_choices');
		if ( ! single || single.length === 0) {
			return;
		}

		try {
			const { default: Choices } = await import(/* webpackChunkName: "choices" */ 'choices.js');
			single.forEach((select) => {
				if (!select.classList.contains('choices__input')) {
					const choicesOptions = get_single_select_choices_options(select, choices_additional_args)
					if(choicesOptions){
						select.choices_instance = new Choices(select, choicesOptions)
					}
				}
			})
		} catch (error) {
			console.error( error.message );
		}
	}

	async singleInput() {
		const single = document.querySelectorAll('.text_input_choices input');
		if ( ! single || single.length === 0) {
			return;
		}

		try {
			const { default: Choices } = await import(/* webpackChunkName: "choices" */ 'choices.js');
			single.forEach((input) => {
				if (!input.classList.contains('choices__input')) {
					try {
						const choicesOptions = {
							shouldSortItems: true,
							editItems: true,
							duplicateItemsAllowed: false,
							removeItemButton: true,
							allowHTML: false
						};
						const wrapper = input.closest('.text_input_choices');

						if (input.placeholder) {
							choicesOptions.placeholder = true;
							choicesOptions.placeholderValue = input.placeholder;
						}

						if (wrapper.classList.contains('numbers_only')) {
							choicesOptions.addItemFilter = (value) => {
								// Allow only numbers
								return /^-?\d+(\.\d+)?$/.test(value);
							};
						}

						new Choices( input, choicesOptions);
					} catch ( error ) {
						console.error( error.message );
					} finally {
					}
				}
			})
		} catch (error) {
			console.error( error.message );
		}
	}

	update() {
		this.multiSelect('.multi_choices.countries select');
		this.multiSelect('.multi_choices.currencies select');
		this.multiSelect('.multi_choices.gateways select');
		this.singleSelect();
		this.singleInput();
	}
}
